<h1 mat-dialog-title><!--
  {{
    actionId && actionId === "660"
      ? ("send_Within.Send" | translate)
      : this.data?.isFromCustomAction
      ? this.data?.actionName
      : ("withinHierarchyDialog.sendCase" | translate)
  }} -->
  {{ getHeader()}}
</h1>
<div mat-dialog-content>
  <dynamic-grid
    #dynamicGrid
    class="grid-cell"
    [rows]="rows"
    [cols]="cols"
    [showSearch]="false"
    [gridFooterActions]="false"
    (onCustomComponentOutput)="onCustomOutput($event)"
  >
  </dynamic-grid>
  <mat-dialog-actions align="end">
    <div class="buttons">
      <button mat-raised-button mat-dialog-close>
        {{ "send_Within.Cancel" | translate }}
      </button>
      <button
        mat-raised-button
        color="primary"
        preventDoubleClick
        (click)="onSend()"
        [disabled]="isButtonDisable()"
      >
        {{ "send_Within.SendIt" | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
